import React, {
  useRef,
  forwardRef,
  useImperativeHandle,
  useState,
  useEffect,
  SyntheticEvent,
} from "react";
import { StyleSettings } from "src/styles/StyleSettings";
import { fnGetDataSet } from "@shared/api/restApi";
import { global } from "@shared/libs/Global";
import { IconButton } from "@mui/material";
import SnGrid from "@shared/components/Grid/SnGrid";
import SnTab from "@shared/components/SnTab";
import { Box, TextField, Typography } from "@mui/material";
import SnButton from "@shared/components/SnButton";
import Autocomplete from "@mui/material/Autocomplete";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import Checkbox from "@mui/material/Checkbox";
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

interface Props {
  slipData: any;
  saveTables: string[];
  modalRef?: any; // 부모 엘리먼트
}

const DesignerMenuEdit = forwardRef(
  (
    {
      slipData = {
        module: { cd_module: "" },
        line: { no_line: 0, nm_prefix: "" },
        prefix: "",
        dt: "",
        column: "",
      },
      saveTables,
      modalRef,
    }: Props,
    ref
  ) => {
    const { userInfo } = global();
    const selectedTabPage = useRef<any>(1);
    const [slip, setSlip] = useState(slipData);
    const [modules, setModules] = useState<any[]>([]);
    const [lines, setLines] = useState<any[]>([]);
    const [options, setOptions] = useState<any[]>([]);
    const [initOption, setInitOption] = useState<any[]>(saveTables || []);

    useEffect(() => {
      const fetchform = async () => {
        const search = {
          queryId: "menuInfo",
          id: "DesignerMapper",
          params: {},
        };
        const data: any = await fnGetDataSet(search);
        setModules(data[0]);
        setOptions(data[1]);
      };
      fetchform();
    }, []);

    useEffect(() => {
      setInitOption(saveTables);
    }, [saveTables]);

    useImperativeHandle(ref, () => ({
      getSelectedRow: () => {
        return [slip, initOption];
      },
    }));

    const onTabChanged = (tabIndex: any) => {
      selectedTabPage.current = tabIndex;
    };

    const moduleChange = async (e: SyntheticEvent, value: any) => {
      setSlip({ ...slip, module: value });
      const search = {
        queryId: "noteCountLine",
        id: "DesignerMapper",
        params: { cd_module: value.cd_module },
      };
      const data: any = await fnGetDataSet(search);
      setLines(data[0]);
    };

    const lineChange = async (e: SyntheticEvent, value: any) => {
      setSlip({
        ...slip,
        line: value,
      });
    };

    const tablesChange = (e: SyntheticEvent, value: any) => {
      const tables = value.map((option: any) => option.table_name);
      setInitOption(tables);
    };
    return (
      <div>
        <SnTab
          titles={["채번룰", "저장테이블"]}
          width={"100%"}
          onTabChanged={onTabChanged}
          body={[
            <div>
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: "150px 1fr",
                  gap: 2,
                  p: 2,
                  border: "1px solid rgb(186,191,199)",
                  height: "100%",
                }}
              >
                <Typography sx={{ alignSelf: "center" }}>채번컬럼</Typography>
                <TextField
                  size="small"
                  name="prefix"
                  value={slip.column}
                  onChange={(
                    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
                  ) => {
                    setSlip({ ...slip, column: e.target.value });
                  }}
                  fullWidth
                  placeholder="필수입력"
                />
                <Typography sx={{ alignSelf: "center" }}>모듈</Typography>
                <Autocomplete
                  size="small"
                  disablePortal
                  options={modules || []}
                  value={slip.module}
                  getOptionLabel={(option) => option.cd_module}
                  renderInput={(params) => <TextField {...params} />}
                  onChange={moduleChange}
                />
                <Typography sx={{ alignSelf: "center" }}>라인</Typography>
                <Autocomplete
                  size="small"
                  disablePortal
                  options={lines || []}
                  getOptionLabel={(option) => option.nm_prefix}
                  value={slip.line}
                  renderInput={(params) => <TextField {...params} />}
                  onChange={lineChange}
                />
                <Typography sx={{ alignSelf: "center" }}>PREFIX</Typography>
                <TextField
                  size="small"
                  name="prefix"
                  value={slip.prefix}
                  onChange={(
                    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
                  ) => {
                    setSlip({ ...slip, prefix: e.target.value });
                  }}
                  fullWidth
                  placeholder="DB에 있으면 입력하지 않아도 됩니다"
                />
                <Typography sx={{ alignSelf: "center" }}>날짜컬럼</Typography>
                <TextField
                  size="small"
                  name="dt"
                  value={slip.dt}
                  onChange={(
                    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
                  ) => {
                    setSlip({ ...slip, dt: e.target.value });
                  }}
                  fullWidth
                  placeholder="당일이면 입력하지 않아도 됩니다"
                />
              </Box>
            </div>,
            <div>
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: "150px 1fr",
                  gap: 2,
                  p: 2,
                  border: "1px solid rgb(186,191,199)",
                  height: "100%",
                }}
              >
                <Typography sx={{ alignSelf: "start", mt: 1 }}>
                  필터링
                </Typography>
                <Autocomplete
                  size="small"
                  multiple
                  options={options}
                  disableCloseOnSelect
                  getOptionLabel={(option) =>
                    typeof option === "string"
                      ? option
                      : (option?.table_name ?? "")
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.table_name === value.table_name
                  }
                  value={options.filter((option: any) =>
                    initOption.includes(option.table_name)
                  )}
                  onChange={tablesChange}
                  renderOption={(props, option, { selected }) => {
                    const { key, ...optionProps } = props;
                    return (
                      <li key={key} {...optionProps}>
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          style={{ marginRight: 8 }}
                          checked={selected}
                        />
                        {option.table_name}
                      </li>
                    );
                  }}
                  style={{ width: "100%" }}
                  renderInput={(params) => (
                    <TextField {...params} placeholder="Columns" />
                  )}
                />
              </Box>
            </div>,
          ]}
        />
      </div>
    );
  }
);

export default DesignerMenuEdit;
